import { render, staticRenderFns } from "./Naxxramas.vue?vue&type=template&id=4efeff8c&"
import script from "./Naxxramas.vue?vue&type=script&lang=js&"
export * from "./Naxxramas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports